export const project = {
  logo: { src: '/images/turbo.png/', width: 94, height: 14 },
  brandColor: '#D23439',
  isMobile: false,
  isTablet: false,
  links: {
    ad: 'elanlar/new',
    adId: 'elanlar',
    topUpPersonalAccount: 'profile#replenishment',
    favourites: 'bookmarks',
    logOut: 'session',
    logIn: 'authentication/new',
    profile: 'profile',
    main: '/'
  },
  user: {
    id: '1',
    phones: ['(050) 888-88-88', '(050) 888-88-77'],
    photo:
      'https://thumbs.dreamstime.com/b/human-face-isolated-white-background-spa-portrait-beautiful-fresh-healthy-woman-beauty-close-up-portrait-beautiful-126143418.jpg'
  }
};
